/** Canonical app paths (v2 is now live on production URLs) */
export const SITE_HOME = '/';
export const JOBS_LIST_PATH = '/jobs';
export const JOB_SEARCH_PATH = '/jobsearch';

/** @deprecated Use SITE_HOME — kept for existing imports */
export const PREVIEW_HOME = SITE_HOME;
/** @deprecated Use JOBS_LIST_PATH — kept for existing imports */
export const PREVIEW_JOBS_LIST = JOBS_LIST_PATH;

const LEGACY_PREVIEW_LIST_PATHS = ['/home-new', '/jobs-list-new', '/jobsearch-new'];

/** SEO category/city job listing slugs served by /:jobs_list */
export function isSeoJobListPath(path) {
  return /-jobs-vacancies$/.test(path) || /^\/jobs-in-/.test(path);
}

export function isJobsIndexPath(path) {
  return path === '/jobs' || path === '/jobs/';
}

export function isJobSearchPath(path) {
  return path === '/jobsearch';
}

export function isJobListPath(path) {
  return isJobsIndexPath(path) || isJobSearchPath(path) || isSeoJobListPath(path);
}

/** @deprecated Preview mode disabled — v2 runs on production routes */
export function isJobListPreviewMode() {
  return false;
}

export function isLegacyPreviewListPath(path) {
  return LEGACY_PREVIEW_LIST_PATHS.includes(path);
}

export function isLegacyJobDetailRedirectPath(path) {
  return path.startsWith('/jobs-new/');
}

export function isJobDetailPath(path) {
  return /^\/jobs\/[^/]+$/.test(path);
}

export function isAuthPath(path) {
  return path.startsWith('/jobseeker/');
}

export function getFooterConfig(path) {
  if (isJobDetailPath(path)) {
    return {
      showStandard: true,
      showSeo: false,
      standardVariant: 'slim',
      mobileBottomPad: true,
    };
  }
  if (isAuthPath(path)) {
    return { showStandard: true, showSeo: false, standardVariant: 'slim', mobileBottomPad: false };
  }
  return { showStandard: true, showSeo: true, standardVariant: 'full', mobileBottomPad: false };
}
